"use client";

import React from "react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const milestonesData = [{
  year: "2014",
  title: "The Foundation",
  description: "IT Masters was established in the UAE with a mission to provide precision technology solutions. We began as a silent engine for digital transformation in the enterprise sector."
}, {
  year: "2017",
  title: "Hospitality Expansion",
  description: "We became a trusted partner for prestigious hotel brands like Marriott, delivering high-stakes virtualization projects and resilient guest service infrastructure."
}, {
  year: "2021",
  title: "Cybersecurity Gold Standard",
  description: "Partnering with world-leading security firms, we implemented edge-to-edge encryption and proactive threat hunting to protect our clients' reputations."
}, {
  year: "2024",
  title: "A Decade of Excellence",
  description: "Celebrating 10 years of bridging the gap between complex technology and business efficiency, scaling infrastructure for leading enterprises globally."
}];
function TimelineItem({
  item,
  index
}: {
  item: (typeof milestonesData)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const isEven = index % 2 === 0;
  return <div ref={ref} data-index={index} className={cn("relative flex flex-col md:flex-row items-start md:items-center justify-between mb-24 last:mb-0 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12", isEven ? "md:flex-row-reverse" : "")}>
      {}
      <div className="absolute left-4 md:left-1/2 top-0 md:top-1/2 -translate-x-1/2 md:-translate-y-1/2 z-10 flex items-center justify-center w-10 h-10 bg-background rounded-md border border-border shadow-md">
        <div className="absolute inset-0 rounded-md bg-primary/20 animate-ping" style={{
        animationDuration: "3s"
      }} />
        <div className="relative w-2.5 h-2.5 rounded-md bg-primary animate-pulse" />
      </div>

      {}
      <div className={cn("w-full md:w-[45%] pl-16 md:pl-0 pt-2 md:pt-0", isEven ? "md:pr-16 md:text-right" : "md:pl-16 md:text-left")}>
        <div className="text-5xl md:text-7xl font-mono font-bold text-primary/10 tracking-tighter mb-4 select-none">
          {item.year}
        </div>
        <h3 className="text-2xl font-default font-bold mb-3 text-foreground">
          {item.title}
        </h3>
        <p className="text-muted-foreground leading-relaxed font-serif">
          {item.description}
        </p>
      </div>

      {}
      <div className="hidden md:block w-[45%]" />
    </div>;
}
export default function Milestones() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223829" id="our-journey-since-2014" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        {}
        <div ref={headerRef} className={cn("text-center mb-20 md:mb-32 transition-all duration-1000 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tight">
            Our Legacy of Precision
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-serif text-lg">
            From our UAE launch to becoming the silent engine behind global hospitality leaders, explore the milestones of IT Masters.
          </p>
        </div>

        {}
        <div className="relative">
          {}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-primary/30 -translate-x-1/2" />

          {}
          <div className="relative z-10">
            {milestonesData.map((item, index) => <TimelineItem key={index} item={item} index={index} />)}
          </div>
        </div>
      </div>
    </section>;
}